<template>
    <div class="container">
        <div class="text-center">
            <b-spinner type="grow" variant="secondary" /><br />
        </div>
    </div>

</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';


    @Component
    export default class Spinner extends Vue {
    }


</script>

<style scoped>

    .container {
        height: 25vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>